export const MAX_SIGNATURE_WIDTH = 420
export const MAX_SIGNATURE_PER_ROW = 2

export const DEFAULT_CURRENT_TIME_CSS_CLASS = `default-current-time`
export const DEFAULT_DATE_MERGE_TAG_MDY = `{date_mdy}`
export const DEFAULT_DATE_MERGE_TAG_DMY = `{date_dmy}`
